export function owlInitialize ( selector, options = {} ) {
    const _defaultOptions = {
        loop: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        margin: 10,
        responsive:{
            0:{
                items: 1,
            },
            600:{
                items: 2,
            },
            768:{
                items: 3,
            },
            1024:{
                items: 4
            },
        }
    };
    const _options = Object.assign( _defaultOptions, options )
    $( selector ).owlCarousel( _options );
};


export function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
        c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
        }
    }
    return "";
};